<template>
  <v-main>
    <h1>{{ number }}</h1>
    <h3>{{ name }}</h3>
    <p>{{ message }}</p>
  </v-main>
</template>

<script>
export default {
  props: {
    number: String,
    name: String,
    message: String
  }
}
</script>
